(() => {
  // app/scripts/truncate-text.js
  var TruncateText = class extends HTMLElement {
    constructor() {
      super();
      this.limit = Number.parseInt(this.getAttribute("limit"), 10) || 15;
      this.handleShowMore = this.handleShowMore.bind(this);
    }
    connectedCallback() {
      const textElement = this.querySelector(".truncate-text__content");
      const showMoreLink = this.querySelector(".show-more-link");
      if (!textElement || !showMoreLink)
        return;
      this.textElement = textElement;
      this.showMoreLink = showMoreLink;
      this.fullText = (this.getAttribute("data-full-text") || textElement.textContent).trim().replace(/\s+/g, " ");
      const words = this.fullText.split(" ").filter(Boolean);
      if (words.length > this.limit) {
        if (this.getAttribute("data-initial-truncated") !== "true") {
          textElement.textContent = words.slice(0, this.limit).join(" ") + "... ";
        }
        showMoreLink.style.display = "";
        showMoreLink.addEventListener("click", this.handleShowMore);
        return;
      }
      showMoreLink.style.display = "none";
    }
    disconnectedCallback() {
      this.showMoreLink?.removeEventListener("click", this.handleShowMore);
    }
    handleShowMore(event) {
      event.preventDefault();
      event.stopPropagation();
      this.textElement.textContent = this.fullText;
      this.showMoreLink.style.display = "none";
    }
  };
  customElements.define("truncate-text", TruncateText);
})();
